import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

/** Loads every help document once: { [key]: { content, filename } }. */
export function useHelpDocs(docKeys) {
  const [docs, setDocs] = useState({});
  const [loading, setLoading] = useState(true);
  const keysSignature = docKeys.join(",");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    Promise.all(keysSignature.split(",").map(async (key) => [key, (await api.get(`/docs/${key}`)).data]))
      .then((results) => { if (!cancelled) setDocs(Object.fromEntries(results)); })
      .catch((err) => { if (!cancelled) toast.error(formatApiError(err, "No se pudo cargar la documentación")); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [keysSignature]);

  return { docs, loading };
}
